/***
 * List header sticky in theme
 * 1) #shopify-section-announcement-bar                      <->
 * 2) #shopify-section-static-header                         <-> Empire < 9.0.0 - D&M
 * 3) #shopify-section-header                                <-> themes: Dawn,Prestige < 7.0,Warehouse, Icon < 9.0 , Symmetry, Focal
 * 4) #SiteHeader                                            <-> Impulse, Expanse, Motion
 * 5) .site-header--opening                                  <-> Impulse, Motion, Streamline
 * 6) .site-header--stuck                                    <-> Impulse, Motion
 * 7) .js-navigation                                         <->
 * 8) .js-mobile-header-wrapper                              <->
 * 9) .mobile-nav-bar-wrapper                                <-> themes: flow -M,
 * 10) header.mobile_nav-fixed--true                         <-> themes: turbo - M
 * 11) .site-header--sticky                                  <->
 * 12) .shopify-section.shopify-section-group-header-group.site-header-wrapper <-> Empire > 9.0.0 - D&M
 * 13) .action-bar-wrapper,                                  <->
 * 14) .scrolled-past-header.shopify-section-header-sticky   <-> themes: Dawn, refresh - D&M
 * 15) .shopify-section__header,                             <-> Warehouse
 * 16) .main-nav__wrapper.sticky_nav > .main-nav             <-> themes: turbo - D
 * 17) .site-header__wrapper                                 <-> themes: Flow -D
 * 18) .shopify-section-navigation .sticky-wrapper .wrapper-navigation, <-> themes: Ella-5.0.9 - D
 * 19) .shopify-section-header .sticky-wrapper .header-bottom`        <-> themes: Ella-5.0.9 - M
 * 20) header.shopify-section.shopify-section-group-header-group.shopify-section--header <-> Prestige > 7.0
 * 21) header.header-section.scrolling                       <-> Icon > 9.0
 * 22) .shopify-section-group-header-group.wau--header.is-stuck .header-section <-> Icon > 10.0.0
 * 23) .shopify-section.shopify-section-group-header-group.shopify-section--header <-> Focal > 10.1.3
 * 24) .js__header__stuck header.theme__header                         <-> Broadcast-5.3.0
 */

export const avoidStickyHeader = `
  #shopify-section-announcement-bar,
  #shopify-section-static-header,
  #shopify-section-header,
  #SiteHeader,
  .site-header--opening,
  .site-header--stuck,
  .js-navigation,
  .js-mobile-header-wrapper,
  .mobile-nav-bar-wrapper,
  header.mobile_nav-fixed--true,
  .site-header--sticky,
  .shopify-section.shopify-section-group-header-group.site-header-wrapper,
  .action-bar-wrapper,
  .scrolled-past-header.shopify-section-header-sticky,
  .shopify-section__header,
  .main-nav__wrapper.sticky_nav > .main-nav,
  .site-header__wrapper,
  #shopify-section-navigation .sticky-wrapper .wrapper-navigation,
  #shopify-section-header .sticky-wrapper .header-bottom,
  header.shopify-section.shopify-section-group-header-group.shopify-section--header,
  header.header-section.scrolling,
  .shopify-section-group-header-group.wau--header.is-stuck .header-section,
  .shopify-section.shopify-section-group-header-group.shopify-section--header,
  .js__header__stuck header.theme__header
`;
